import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";

interface IListStateIconStartedProps {
  noMargin?: boolean;
  color?: string;
  tooltip?: string;
}

export const ListStateIconStarted = (props: IListStateIconStartedProps) => (
    <ListStateIcon
        icon={ChangeCircleIcon}
        tooltip={props.tooltip}
        color={props.color}
        noMargin={props.noMargin}
    />
);
